/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Box, Button, Grid, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import { setModalErrorVisible } from "@store/slices/appSlice";
import { useLazyGetCuentasByIdQuery } from "@api/account";
import { ApiError } from "@interfaces/response";
import IconSpeed from "@components/Images/IconSpeed";

interface SolicitudInactivaProps {
  isDemo?: boolean;
}

const SolicitudInactiva = (props: SolicitudInactivaProps) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const personalData = useSelector((state: RootState) => state.register.personal_data);

  const [getAccountData] = useLazyGetCuentasByIdQuery();

  const [name, setName] = useState("");

  const handleClick = async () => {
    console.log("Reactivar solicitud...");
  };

  const fetchData = async () => {
    try {
      const response = await getAccountData({ id: personalData.id }).unwrap();
      const account_data = response.data;
      const fullName = `${account_data.name} ${account_data.last_name} ${account_data.last_name_2}`.trim();
      setName(fullName);
    } catch (error) {
      dispatch(setModalErrorVisible({ open: true, error: error as ApiError }));
    }
  };

  useEffect(() => {
    document.body.style.backgroundColor =
      theme?.palette?.screens?.bofu?.backgroundColor || theme?.palette?.primary?.base;
    if (!props.isDemo) {
      fetchData();
    }

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <Grid
      container
      height="100%"
      sx={{
        color: theme?.palette?.screens?.bofu?.titleColor || theme?.palette?.primary?.dark,
      }}
    >
      <Grid item xs={12} md={8} mt={5}>
        <InactivityHandler />
        <Box textAlign="center">
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screens?.bofu?.titleColor || theme?.palette?.primary?.main}
            fontWeight="bold"
          >
            ¡Hola!
          </Typography>

          <Typography variant={isMobileOrTablet ? "h4" : "h3"} fontWeight="bold" mt={2}>
            {name || "Nombre del cliente"}
          </Typography>

          <Typography variant={isMobileOrTablet ? "body2" : "body1"} mt={2}>
            Tu solicitud se desactivo por inactividad.
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screens?.bofu?.subtitleColor || theme?.palette?.primary?.main}
            mt={2}
            fontWeight="bold"
          >
            Si deseas continuar, puedes reactivarla ahora.
          </Typography>

          <Box display="flex" justifyContent="center" mt={4}>
            <IconSpeed
              width={isMobileOrTablet ? "110" : "170"}
              fill={theme?.palette?.screens?.bofu?.iconColor || theme.palette.primary.dark}
            />
          </Box>

          <Box display="flex" justifyContent="center" mt={4}>
            <Button variant="default" onClick={handleClick}>
              Reactivar solicitud
            </Button>
          </Box>

          <Typography variant={isMobileOrTablet ? "body2" : "body1"} mt={4}>
            Para cualquier duda o aclaración contáctanos a: <br />
            Tel: <Link href="tel:+525591044964">55 9104 4964</Link> <br />
            Correo: <Link href="mailto:contacto@lendia.mx">contacto@lendia.mx</Link>
          </Typography>
        </Box>
      </Grid>

      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default SolicitudInactiva;
